function convertNumberedLinesToList(html: string) {
  const lines = html.split(/\r?\n|<br\s*\/?>/i);
  const listItems: string[] = [];
  const otherLines: string[] = [];

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (/^\d+\s*-\s*/.test(trimmed)) {
      listItems.push(trimmed.replace(/^\d+\s*-\s*/, ""));
    } else {
      otherLines.push(trimmed);
    }
  });

  let result = otherLines.join("<br>");
  if (listItems.length) {
    result += `<ol>${listItems.map((li) => `<li>${li}</li>`).join("")}</ol>`;
  }

  return result;
}

function isRTLText(text: string) {
  const stripped = text.replace(/<[^>]+>/g, "");
  return /^[\s]*[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(stripped);
}

function cleanHtml(html: string) {
  return html
    .replace(/<\/br>/gi, "<br>")
    .replace(/<br\s*\/?>\s*<br\s*\/?>/gi, "<br>")

    .replace(/<li>([^<]+)(?=<li>|<\/ul>|<\/ol>)/gi, "<li>$1</li>")

    .replace(/<fieldset[^>]*>/gi, "<div class='fieldset'>")
    .replace(/<\/fieldset>/gi, "</div>")
    .replace(/<legend[^>]*>/gi, "<div class='legend'>")
    .replace(/<\/legend>/gi, "</div>")

    .replace(/&nbsp;/g, " ")
    .replace(/\u00A0/g, " ")

    .replace(/\s{2,}/g, " ");
}

function removeDuplicateBlocks(html: string) {
  const marker = "These Are Non Refundable Fares.";
  const firstIndex = html.indexOf(marker);

  if (firstIndex === -1) return html;

  const secondIndex = html.indexOf(marker, firstIndex + marker.length);

  if (secondIndex === -1) return html;

  return html.slice(0, secondIndex);
}
export {removeDuplicateBlocks, cleanHtml,convertNumberedLinesToList,isRTLText}